import { useQueryClient as s, useMutation as o } from "@tanstack/vue-query";
import { adGroupKeys as y } from "../ad-group/queries.js";
import { campaignKeys as c } from "../campaign/queries.js";
import "../creative-group/queries.js";
import { targetGroupKeys as u } from "./queries.js";
const G = (i, n) => {
  const r = s(), a = n?.onSuccess;
  return o({
    ...n,
    mutationFn: async (e) => {
      const t = {
        campaignId: e.campaignId,
        ...e.body
      };
      return i.targetGroup.create(t);
    },
    onSuccess: async (...e) => {
      const [, t] = e;
      await r.invalidateQueries({ queryKey: u.byCampaign(t.campaignId) }), await r.invalidateQueries({ queryKey: c.all }), a && a(...e);
    }
  });
}, q = (i, n) => {
  const r = s(), a = n?.onSuccess;
  return o({
    ...n,
    mutationFn: async (e) => {
      const t = {
        campaignId: e.campaignId,
        ...e.body
      };
      return i.targetGroup.copy(t);
    },
    onSuccess: async (...e) => {
      const [, t] = e;
      await r.invalidateQueries({ queryKey: u.byCampaign(t.campaignId) }), await r.invalidateQueries({ queryKey: c.all }), a && a(...e);
    }
  });
}, Q = (i, n) => {
  const r = s(), a = n?.onSuccess;
  return o({
    ...n,
    mutationFn: async (e) => {
      const t = {
        targetGroupId: e.targetGroupId,
        ...e.body
      };
      return i.targetGroup.update(t);
    },
    onSuccess: async (...e) => {
      const [, t] = e;
      await r.invalidateQueries({ queryKey: u.byCampaign(t.campaignId) }), await r.invalidateQueries({ queryKey: c.all }), await r.invalidateQueries({ queryKey: y.byCampaign(t.campaignId) }), a && a(...e);
    }
  });
}, K = (i, n) => {
  const r = s(), a = n?.onSuccess;
  return o({
    ...n,
    mutationFn: async (e) => {
      await i.targetGroup.rename({
        targetGroupId: e.targetGroupId,
        ...e.body
      });
    },
    onSuccess: async (...e) => {
      const [, t] = e;
      await r.invalidateQueries({ queryKey: u.byCampaign(t.campaignId) }), await r.invalidateQueries({ queryKey: c.all }), a && a(...e);
    }
  });
}, v = (i, n) => {
  const r = s(), a = n?.onSuccess;
  return o({
    ...n,
    mutationFn: async (e) => i.targetGroup.remove({ targetGroupId: e.targetGroupId }),
    onSuccess: async (...e) => {
      const [, t] = e;
      r.removeQueries({
        queryKey: u.detail(t.campaignId, t.targetGroupId)
      }), await r.invalidateQueries({ queryKey: u.byCampaign(t.campaignId) }), await r.invalidateQueries({ queryKey: c.all }), a && a(...e);
    }
  });
}, C = (i, n) => {
  const r = s();
  return o({
    ...n,
    mutationFn: async (a) => {
      const e = {
        targetGroupId: a.targetGroupId,
        ...a.body
      };
      return i.targetGroup.update(e);
    },
    onMutate: async (a) => {
      await r.cancelQueries({
        queryKey: u.detail(a.campaignId, a.targetGroupId)
      });
      const e = r.getQueryData(
        u.detail(a.campaignId, a.targetGroupId)
      );
      if (e) {
        const { dimensions: t, ...d } = a.body;
        r.setQueryData(u.detail(a.campaignId, a.targetGroupId), {
          ...e,
          ...d
        });
      }
      return e !== void 0 ? { previousData: e } : {};
    },
    onError: (a, e, t) => {
      t?.previousData && r.setQueryData(
        u.detail(e.campaignId, e.targetGroupId),
        t.previousData
      );
    },
    onSettled: async (a, e, t) => {
      await r.invalidateQueries({ queryKey: u.byCampaign(t.campaignId) }), await r.invalidateQueries({ queryKey: c.all }), await r.invalidateQueries({ queryKey: y.byCampaign(t.campaignId) });
    }
  });
};
export {
  q as useCopyTargetGroup,
  G as useCreateTargetGroup,
  v as useDeleteTargetGroup,
  K as useRenameTargetGroup,
  Q as useUpdateTargetGroup,
  C as useUpdateTargetGroupOptimistic
};
//# sourceMappingURL=mutations.js.map
